export default __webpack_public_path__ + "static/media/stronaBudowa.fccc0852.jpg";